export default {
    emitEventGoogleAnalytics($ga, eventCategory, eventAction) {
        if ($ga) {
            $ga.event({
                eventCategory,
                eventAction,
            })
        }
    },

    emitLogInGoogleAnalytics($ga) {
        this.emitEventGoogleAnalytics($ga, 'sign-in', 'log-in')
    },

    emitRegistrationGoogleAnalytics($ga) {
        this.emitEventGoogleAnalytics($ga, 'sign-up', 'new-registration')
    },

    emitRegistrationByInviteGoogleAnalytics($ga) {
        this.emitEventGoogleAnalytics($ga, 'sign-up', 'new-registration-by-invite')
    },

    emitRegistrationByAdminGoogleAnalytics($ga) {
        this.emitEventGoogleAnalytics($ga, 'sign-up', 'new-registration-by-admin')
    },

    emitRegistrationCompletedGoogleAnalytics($ga) {
        this.emitEventGoogleAnalytics($ga, 'sign-up', 'registration-completed')
    },
}
